import { render, staticRenderFns } from "./ArticleAll.vue?vue&type=template&id=b5a2ca32&scoped=true"
import script from "./ArticleAll.vue?vue&type=script&lang=js"
export * from "./ArticleAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a2ca32",
  null
  
)

export default component.exports